import React, {  Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { requery } from "../../../actions/updateHelp";
import ReactDatatable from "@ashvin27/react-datatable";
import { withRouter } from "react-router-dom";
import * as myConstList from "../../../BaseUrl";
import moment from "moment";
const callBackBaseUrl = myConstList.callBackBaseUrl;
const capitalizeFunc = myConstList.capitalize;
class WinningHistory extends React.Component {
  constructor(props) {
    super(props);
    const { user } = this.props.auth;
    this.state = {
      records: [],
      id: this.props.id,
      description: "",
      message: "",
      username: user.name,
      showResults: false,
      showTeaxtArea: true,
      urltemp: "",
      errors: {},
    };
    // reactData Table
    // this.columns = [
    //   {
    //     key: "",
    //     text: "S. No.",
    //     classNameName: "contestName",
    //     align: "left",
    //     sortable: true,
    //     cell: (row, index) => index + 1,
    //   },
    //   {
    //     key: "contestName",
    //     text: "Transaction Type",
    //     classNameName: "contestName",
    //     align: "left",
    //     sortable: true,
    //   },
    //   {
    //     key: "winningAmount",
    //     text: "Amount",
    //     classNameName: "winningAmount",
    //     align: "left",
    //     sortable: true,
    //   },
    //   {
    //     key: "winningAmount",
    //     text: "Transaction ID",
    //     classNameName: "winningAmount",
    //     align: "left",
    //     sortable: true,
    //   },
    //   {
    //     key: "numOfParticipation",
    //     text: "Currency Type",
    //     classNameName: "numOfParticipation",
    //     align: "left",
    //     sortable: true,
    //   },
    //   {
    //     key: "startDate",
    //     text: "Date",
    //     classNameName: "startDate",
    //     align: "left",
    //     sortable: true,
    //     cell: (record) => {
    //       return (
    //         <Fragment>
    //           {moment(record.date).format("lll")}
    //         </Fragment>
    //       );
    //     },
    //   },
    //   {
    //     key: "startDate",
    //     text: "Status",
    //     classNameName: "startDate",
    //     align: "left",
    //     sortable: true,
    //   },
    // ];

    this.columns = [
      {
        key: "id",
        text: "Id",
        className: "id",
        align: "left",
        sortable: true,
        cell: (row, index) => index + 1,
      },      
      {
        key: "contestName",
        text: "Contest Name",
        className: "Amount",
        align: "left",
        sortable: true,
      },
      {
        key: "coin_amount",
        text: "Coin Amount",
        className: "Amount",
        align: "left",
        sortable: true,
        // cell: (record) => {
        //   return (
        //     <Fragment>
        //       {record.winningPrize !== undefined
        //         ? record.amount + "   " + record.winningPrize
        //         : record.amount}
        //     </Fragment>
        //   );
        // },
      },
      {
        key: "coin_amount",
        text: "Wining Type",
        className: "Amount",
        align: "left",
        sortable: true,
        cell: (record) => {
          return (
            <Fragment>
              {record.amount_type == 'coin_amount'
                ? "Coins"
                : ""}
                {record.amount_type == 'point_amount'
                ? "Points"
                : ""}
            </Fragment>
          );
        },
      },
      // {
      //   key: "contestName",
      //   text: "Contest Name",
      //   className: "Contest Name",
      //   sortable: true,
      //   align: "left",
      //   cell: (record) => {
      //     return (
      //       <Fragment>
      //         {/* {<Link to={"/trading-contest/"+record.contest_id._id}> {capitalizeFunc(record.contest_id.contestName)}</Link>} */}
      //         {
      //           <a href={"/trading-contest/" + record.contest_id}>
      //             {capitalizeFunc(record.contestName)}
      //           </a>
      //         }
      //       </Fragment>
      //     );
      //   },
      // },
      {
        key: "tx_id",
        text: "Transaction ID",
        className: "transType",
        align: "left",
        sortable: true,
      },
      {
        key: "date",
        text: "Date",
        className: "date",
        align: "left",
        sortable: true,
        cell: (record) => {
          return <Fragment>{moment(record.date).format("lll")}</Fragment>;
        },
      },
    ];
  }
  componentDidMount() {
    if (
      localStorage.getItem("source") !== "" &&
      localStorage.getItem("theme") !== ""
    ) {
      const urltemp =
        "?source=" +
        localStorage.getItem("source") +
        "&theme=" +
        localStorage.getItem("theme");
      this.setState({ urltemp: urltemp });
    }
    if (!this.props.auth.isAuthenticated) {
      window.location = callBackBaseUrl + "?callBack=" + window.location.origin;
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.record) {
      this.setState({
        records: nextProps.record,
      });
    }
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
      });
    }
    if (
      nextProps.auth !== undefined &&
      nextProps.auth.user !== undefined &&
      nextProps.auth.user.data !== undefined &&
      nextProps.auth.user.data.message !== undefined &&
      nextProps.auth.user.data.success
    ) {
      this.setState({
        message: nextProps.auth.user.data.message,
      });
    }
  }

  render() {
    return (
      <div className="crypt-market-status2 mt-4 p-2 p-sm-3">
        <div className=" table-striped mb-0">
          <div className="ccrool_table">
            <ReactDatatable
              records={this.state.records}
              columns={this.columns}
            />
          </div>
        </div>
      </div>
    );
  }
}

WinningHistory.propTypes = {
  requery: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default connect(mapStateToProps, { requery })(
  withRouter(WinningHistory)
);
